import { defineFakeRoute } from 'vite-plugin-fake-server/client';
import { resultError, resultSuccess, routeParam } from '../business/utils';
import {
  addServer,
  changeRegistration,
  discoveredInstances,
  linkDiscoveredInstance,
  ServerRegistrationError,
} from './server-registration-store';

function attempt<T>(operation: () => T) {
  try {
    return resultSuccess(operation());
  } catch (error) {
    if (error instanceof ServerRegistrationError)
      return resultError(error.message, error.status);
    throw error;
  }
}
function bodyOf(body: unknown): Record<string, unknown> {
  if (!body || typeof body !== 'object' || Array.isArray(body))
    throw new ServerRegistrationError(422, '请求内容无效');
  return body as Record<string, unknown>;
}
export default defineFakeRoute([
  {
    url: '/platform/servers',
    method: 'post',
    response: ({ body }) => attempt(() => addServer(bodyOf(body))),
  },
  ...(['check', 'regenerate', 'cancel'] as const).map((action) => ({
    url: `/platform/servers/:id/registration/${action}`,
    method: 'post' as const,
    response: ({
      params,
      body,
    }: {
      params: Record<string, string | string[]>;
      body: unknown;
    }) =>
      attempt(() =>
        changeRegistration(
          routeParam(params.id) ?? '',
          action,
          bodyOf(body).expectedVersion,
        ),
      ),
  })),
  {
    url: '/platform/servers/:id/discovered-instances',
    method: 'get',
    response: ({ params }) =>
      attempt(() => discoveredInstances(routeParam(params.id) ?? '')),
  },
  {
    url: '/platform/servers/:id/instances',
    method: 'post',
    response: ({ params, body }) =>
      attempt(() => linkDiscoveredInstance(routeParam(params.id) ?? '', bodyOf(body))),
  },
]);
